<template>
	<div id="app" class="flex flex-col relative min-h-screen font-sans leading-tight text-gray-600">
		<component :is="layout" class="flex-1 flex flex-col">
			<router-view :key="$route.fullPath" />
		</component>
		<portal-target name="modals" multiple></portal-target>
		<div class="z-40 transition delay-150 duration-300 absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 opacity-0" :class="[$store.getters.isLoading ? 'opacity-100' : 'pointer-events-none']" >
			<div class="flex flex-col justify-center text-blue-600 fixed">
				<refresh-cw-icon class="text-blue-600 mx-auto mb-2 animate-spin" size="1.5x"></refresh-cw-icon>
				<div class="">please wait</div>
			</div>
		</div>
	</div>
</template>
<script>
const DefaultLayout = 'default'
export default {
	data () {
		return {}
	},
	computed: {
		layout () {
			return (this.$route.meta.layout || DefaultLayout) + '-layout'
		},
		showOverlay () {
			return this.$store.getters.isLoading
		}
	},
	methods: {

	},
	watch: {
		showOverlay: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	mounted: function () {
		this.$http.interceptors.response.use(undefined, function (err) {
			return new Promise(function (resolve, reject) {
				if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
					this.$store.dispatch('logout')
				}
				throw err
			})
		})
		/* iOS re-orientation fix */
		if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
		    /* iOS hides Safari address bar */
		    window.addEventListener("load",function() {
		        setTimeout(function() {
		            window.scrollTo(0, 1);
		        }, 1000);
		    });
		}
	}
}
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Nunito:400,700,900&display=swap");
#nav a {
	color: #2c3e50;
}

#nav a.router-link-exact-active {
	color: #42b983;
}
</style>
